import cx from "classnames";
import { Component } from "react";
import { connect } from "react-redux";
import { SessionHelper } from "../../helpers/sessionHelper";
import type { NotificationType } from "../../types/notificationType";
import Notification from "./components/Notification/Notification";
import "./NotificationDisplay.scss";
type Props = {
  setNotificationPlatform: (...args: Array<any>) => any;
  loadNotifications: (...args: Array<any>) => any;
  notificationList: NotificationType[];
  setNotificationListTotal: (...args: Array<any>) => any;
  setShowNotificationDisplay: (...args: Array<any>) => any;
  clearNotifications: (...args: Array<any>) => any;
  total: number;
  isIdle: boolean;
};
type State = {
  closedIds: any;
  index: number;
};

class NotificationDisplay extends Component<Props, State> {
  filteredNotificationList: NotificationType[];
  loopIntervalId: any;
  intervalId: any;
  index: number;

  constructor(props) {
    super(props);
    this.state = {
      closedIds: window.localStorage.getItem("notification-ids")
        ? window.localStorage.getItem("notification-ids").split(",")
        : [],
      index: 0,
    };
    this.filteredNotificationList = [];
    this.index = 0;
    this.loopIntervalId = null;
    this.intervalId = null;
    const platform = SessionHelper.isAuthenticated() ? "WEBSITE" : "HOMEPAGE";
    this.props.setNotificationPlatform(platform);
    this.props.loadNotifications();
    this.startPolling();
  }

  componentDidUpdate() {
    if (!this.loopIntervalId && this.filteredNotificationList.length > 0) {
      this.startNotificationLoop();
    }

    this.props.setShowNotificationDisplay(
      this.filteredNotificationList.length > 0
    );
  }

  componentWillUnmount() {
    this.stopNotificationLoop();
    this.stopPolling();
  }

  onClickClose = (id: string) => {
    let idList = this.state.closedIds;
    idList.push(id.toString());
    const nextIndex =
      this.state.index >= this.filteredNotificationList.length - 1
        ? 0
        : this.state.index + 1;
    this.setState({
      closedIds: idList,
      index: nextIndex,
    });
    window.localStorage.setItem("notification-ids", idList.join(","));
    this.forceUpdate();
  };
  startNotificationLoop = () => {
    this.loopIntervalId = setInterval(() => {
      const nextIndex =
        this.state.index >= this.filteredNotificationList.length - 1
          ? 0
          : this.state.index + 1;
      this.setState({
        index: nextIndex,
      });
    }, 5000);
  };
  stopNotificationLoop = () => {
    clearInterval(this.intervalId);
  };
  startPolling = () => {
    this.intervalId = setInterval(() => {
      if (!this.props.isIdle) {
        this.props.loadNotifications();
      }
    }, 30000);
  };
  stopPolling = () => {
    clearInterval(this.intervalId);
  };

  render() {
    if (this.props.notificationList === undefined) return <div></div>;
    this.filteredNotificationList = this.props.notificationList.filter(
      notification => {
        return !this.state.closedIds.includes(notification.id.toString());
      }
    );
    return (
      <div
        className={cx("notification-display", {
          "notification-display--has-items":
            this.filteredNotificationList.length > 0 &&
            this.filteredNotificationList[this.state.index],
        })}
      >
        <div className="notification-display__list">
          {this.filteredNotificationList.length > 0 &&
            this.filteredNotificationList[this.state.index] && (
              <Notification
                notification={this.filteredNotificationList[this.state.index]}
                onClose={this.onClickClose}
                closedIds={this.state.closedIds}
              />
            )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  notificationList: state.notificationListModel.notificationList,
  total: state.notificationListModel.total,
  isIdle: state.sessionModel.isIdle,
});

const mapDispatchToProps = dispatch => ({
  setNotificationPlatform: platform => {
    dispatch.notificationListModel.setPlatform(platform);
  },
  loadNotifications: platform => {
    dispatch.notificationListModel.loadNotificationList();
  },
  clearNotifications: () => {
    dispatch.notificationListModel.purgeNotificationList();
  },
  setShowNotificationDisplay: show => {
    dispatch.notificationListModel.setShowNotificationDisplay(show);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationDisplay) as any;
